import { render, staticRenderFns } from "./InvitacionesPasoButacas.vue?vue&type=template&id=013f508c"
import script from "./InvitacionesPasoButacas.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesPasoButacas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports